module.exports = __webpack_public_path__ + "static/media/ireform_visual_drag.a0899ecb.png";